<template>
  <v-card outlined max-width="380" min-width="200" class="mb-5">
    <v-card-subtitle class="pb-0"> カテゴリ・タグ </v-card-subtitle>
    <div>
      <v-card-text>
        <TagSelector
          :tag="category"
          label="カテゴリ"
          :disabled="mode === 'readonly'"
          @change-tag="setCategory"
        ></TagSelector>
      </v-card-text>
    </div>
    <div>
      <v-card-text>
        <multiple-tag-selector
          :tags="littleTags"
          label="タグ"
          :disabled="mode === 'readonly'"
          @change-tag="setTags"
        />
      </v-card-text>
    </div>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'
import TagSelector from '@/components/commons/tags/TagSelector'
import MultipleTagSelector from '@/components/commons/tags/MultipleTagSelector'

export default {
  name: 'TagField',
  components: { MultipleTagSelector, TagSelector },
  computed: {
    ...mapState({
      mode: (state) => state.PostEditor.mode
    }),
    category: {
      get () {
        return this.$store.state.PostEditor.post.category
      },
      set (category) {
        return this.$store.commit('PostEditor/UPDATE_CATEGORY', category)
      }
    },
    littleTags: {
      get () {
        return this.$store.state.PostEditor.post.littleTags
      },
      set (littleTags) {
        return this.$store.commit('PostEditor/UPDATE_LITTLE_TAGS', littleTags)
      }
    }
  },
  methods: {
    setCategory (value) {
      this.category = value
    },
    setTags (value) {
      this.littleTags = value
    }
  }
}
</script>

<style scoped></style>
